import React, { useEffect, useState } from "react";
import moment from "moment-timezone";
import { Select, Modal, Button } from "antd";
import { Layout } from "../Common/Component";
import {aboutUsData} from "../../Assets/data/aboutUsList";

const REGULAR_EXPRESSION_EMAIL = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const { Option } = Select;

function ServiceType(props) {
  const options = aboutUsData;

  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState("");
  const [loader, setLoader] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [staffModal, setStaffModal] = useState(false);
  const [validEmail, setValidEmail] = useState(false);
  const [trackingUuid, setTrackingUuid] = useState(null);
  const [originalType, setOriginaltype] = useState(null);
  const [continueFlag, setContinueFlag] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [selectedServiceType, setSelectedServiceType] = useState("");
  const [howDoYouhearAboutUs, setHowDoYouhearAboutUs] = useState("");
  const [isExistingCustomer, setIsExistingCustomer] = useState(false);
  const [isTrackingRequesting, setIsTrackingRequesting] = useState(false);
  const [openSubscriptionModal, setOpenSubscriptionModal] = useState(false);
  const [isRequetingTackingUuid, setIsRequetingTackingUuid] = useState(false);
  const [staffModalData, setStaffModalData] = useState("");
  const origin = window.location.origin;

  // Basic details
  const [quoteUUId, setQuoteUUId] = useState("");
  const [proposalUUId, setProposalUUId] = useState("");

  useEffect(() => {
    let property_type = JSON.parse(localStorage.getItem("is_property_type")) || null;

    if (property_type && property_type?.property_type === "residential") {
      props.history.push("/subscription");
    }
    if (property_type && property_type?.property_type === "community") {
      props.history.push("/commercial");
    }
  });

  useEffect(() => {
    setTrackingUuid(props?.CustomerStep?.data?.uuid || null);
    setIsRequetingTackingUuid(false);

    if (continueFlag) {
      movedToNext();
      setLoader(false);
    }
  }, [props?.CustomerStep?.data]);

  useEffect(() => {
    sessionStorage.setItem( "quote", JSON.stringify(props.quote?.uuid));

    if(originalType === "residential" && selectedServiceType === "commercial")
    {
      props.getCommercialProposal(props.quote.uuid);
    }
  }, [props.quote?.uuid]);

  // Tracking Management  
  useEffect(() => {
    (async () => {
      if(continueFlag)
      {
        if(!isExistingCustomer)
        {
          if(!isTrackingRequesting || trackingUuid === null)
          {
            if(props?.quote?.uuid && selectedServiceType === "commercial")
            {
              props.registerCustomerLastCompletedStep({
                step: 1,
                lead_commercial: props?.quote?.uuid
              }).then (() => {
                movedToNext();
              });
              
              setIsTrackingRequesting(true);
            }
            
            if(props.ResRegister?.data?.uuid && selectedServiceType === "residential")
            {
              props.registerCustomerLastCompletedStep({
                step: 1,
                lead_residential: props?.ResRegister?.data?.uuid
              }).then (() => {
                movedToNext();
              });
            
              setIsTrackingRequesting(true);
            }
          }
        }
  
        if(isExistingCustomer)
        {
          if(!isTrackingRequesting  && trackingUuid !== null)
          {
            if( originalType === selectedServiceType)
            {
              props.updateCustomerLastCompletedStep({
                step: 1,
                tracking_uuid: trackingUuid
              }).then (() => {
                movedToNext();
              });
            }
          }
          else
          {
            if(props?.quote?.uuid && selectedServiceType === "commercial")
            {
              props.registerCustomerLastCompletedStep({
                step: 1,
                lead_commercial: props?.quote?.uuid
              }).then (() => {
                movedToNext();
              });
            
              setIsTrackingRequesting(true);
            }
            
            if(props.ResRegister?.data?.uuid && selectedServiceType === "residential")
            {
              props.registerCustomerLastCompletedStep({
                step: 1,
                lead_residential: props?.ResRegister?.data?.uuid
              }).then (() => {
                movedToNext();
              });
            
              setIsTrackingRequesting(true);
            }
          }
        }

        movedToNext();
      }
    }) ();
  }, [continueFlag, props?.ResRegister, props.quote]);

  useEffect(() => {
    sessionStorage.setItem("tracking_uuid", JSON.stringify(props?.CustomerStep?.data?.uuid));
  }, [trackingUuid, props?.CustomerStep?.data]);

  useEffect(() => {
    (async () => {
      if(isExistingCustomer && !props?.CustomerStep?.data?.uuid)
      {
        if(props?.proposal?.results?.length > 0 || Object.keys(props.quote).length > 0
          && !isRequetingTackingUuid && selectedServiceType === "commercial")
        {
          await props.getCustomerLastCompletedStepUUID({
            lead_commercial: props?.registered_proposal?.results[0]?.commercial_quote_uuid || props.quote?.uuid
          });

          setIsRequetingTackingUuid(true);
        }
        
        if(props?.ResRegister?.data?.uuid && !isRequetingTackingUuid
          && selectedServiceType === "residential")
        {
          await props.getCustomerLastCompletedStepUUID({
            lead_residential: props?.ResRegister?.data?.uuid
          });

          setIsRequetingTackingUuid(true);
        }
      }
    }) ();
  }, [isExistingCustomer, props?.proposal, props?.ResRegister]);

  useEffect(() => {
    (async () => {
      if (props?.registered_proposal?.results?.length > 0 && !isExistingCustomer)
      {
        const proposal = props?.registered_proposal?.results[0];
        setHowDoYouhearAboutUs(proposal?.commercial_quote?.hear_about_us?.[0])
        const area = JSON.parse(sessionStorage.getItem("area"));
        let params = {
          email_address: email,
          zip_code: area?.zipcode,
          field_office_uuid: area?.uuid,
        };

        if(!isExistingCustomer)
        {
          await props.addCommercialQuote(params);
        }

        // Save basic details for commercial
        sessionStorage.setItem("email", JSON.stringify(email));
        sessionStorage.setItem( "quote", JSON.stringify(proposal.commercial_quote_uuid));
        sessionStorage.setItem( "proposal", JSON.stringify(proposal.uuid));
        sessionStorage.setItem( "inner", JSON.stringify(proposal?.inner_proposals[0]?.uuid));
        sessionStorage.setItem( "hear_about_us", howDoYouhearAboutUs ? howDoYouhearAboutUs : "");
      
        if(!openSubscriptionModal && continueFlag)
        {
          props.history.push("/commercial");
        }
      }
    })();
  }, [props?.registered_proposal]);

  useEffect(() => {
    (async () => {
      if (props?.quote?.uuid  && (!isExistingCustomer || 
        (isExistingCustomer && Object.keys(props?.proposal).length === 0))) {
        const quote_params = {
          proposal_status: "enquiry",
          commercial_quote_uuid: props?.quote?.uuid,
          proposal_date: props?.quote?.proposal_due
            ? moment(props?.quote?.proposal_due).format("YYYY-MM-DD")
            : null,
        };

        setQuoteUUId(props?.quote?.uuid);
        await props.addCommercialProposal(quote_params);
      }
    })();
  }, [props.quote]);

  useEffect(() => {
    (async () => {
      if (props?.proposal?.results?.length > 0) {
        setProposalUUId(props?.proposal?.results[0]?.uuid);
        
        await props.addInnerCommercialProposal({
          proposal_uuid: props?.proposal?.results[0]?.uuid,
          line_items: [],
        });
      }
    })();
  }, [props?.proposal]);

  // Save for Commercial
  useEffect(() => {
    if (props?.addInnerProposal?.uuid) {
      // Save the basic info for commercial
      sessionStorage.setItem("email", JSON.stringify(email));
      sessionStorage.setItem("quote", JSON.stringify(quoteUUId));
      sessionStorage.setItem("proposal", JSON.stringify(proposalUUId));
      sessionStorage.setItem("hear_about_us",JSON.stringify(howDoYouhearAboutUs ? howDoYouhearAboutUs : ""));
      sessionStorage.setItem("inner",JSON.stringify(props?.addInnerProposal?.uuid));
    }

    setLoader(false);
  }, [props.addInnerProposal]);

  // Save for Residential
  useEffect(() => {
    if (props?.ResRegister?.data?.uuid) {
      // Save the basic info for residential
      sessionStorage.setItem("email", JSON.stringify(email));
      sessionStorage.setItem("hear_about_us", howDoYouhearAboutUs ? howDoYouhearAboutUs : "");
      sessionStorage.setItem("lead", JSON.stringify(props?.ResRegister?.data?.uuid));

      if (props?.ResRegister?.data?.hear_about_us) {
        setHowDoYouhearAboutUs(props?.ResRegister?.data?.hear_about_us?.[0])
      }
    }
    
    setLoader(false);
  }, [props?.ResRegister]);

  const movedToNext = () => {
    if (continueFlag && trackingUuid !== null) {
      sessionStorage.setItem("hear_about_us", howDoYouhearAboutUs ? howDoYouhearAboutUs : "");
      
      if (props?.ResRegister?.data?.uuid && selectedServiceType === "residential")
      {
        props.history.push("/subscription");
      }
      
      if ((props?.quote?.uuid || props?.registered_proposal?.results[0]?.commercial_quote_uuid)
        && selectedServiceType === "commercial")
      {
        props.history.push("/commercial");
      }
    }
  }

  const getHistoricalData = (loginClicked) => {
    const area = JSON.parse(sessionStorage.getItem("area"));
    props.getHistoricalData({zipcode: area.zipcode, login_clicked: loginClicked, email: email})
    return true
  }

  useEffect(() => {
    if (props?.quote_info?.hear_about_us) {
      setHowDoYouhearAboutUs(props?.quote_info?.hear_about_us?.[0])
    }
  },[props?.quote_info])

  useEffect(() => {
    setHowDoYouhearAboutUs("")
  }, [])

  // New email verify
  useEffect(() => {
    (async () => {
      if (Object.keys(props.email?.data).length > 0)
      {
        setStaffModal(false);
        if (REGULAR_EXPRESSION_EMAIL.test(email))
        {
          if (props.email?.data?.role !== "lead")
          {
            if(props.email?.data?.role === "Staff")
            {
              let staffModalDataValue = "";
              staffModalDataValue = (props.email?.data?.error).split("<a>").join(`<a href="mailto:PoopNetsupport@doodycalls.com">`);
              setStaffModal(true)
              setStaffModalData(staffModalDataValue)
            }
            getHistoricalData(false);
            setOpenModal(true);
            setValidEmail(false);

            sessionStorage.setItem("is_lead", JSON.stringify("false"));
          } else if ( props.email?.data?.role === "lead" && props.email?.data?.type !== "new") 
          {
            sessionStorage.setItem("email", JSON.stringify(email));
            sessionStorage.setItem("is_lead", JSON.stringify("true"));
            setSelectedServiceType(props?.email?.data?.type);
            setOriginaltype(props?.email?.data?.type);
            setIsExistingCustomer(true);

            if (props.email?.data?.type === "residential")
            {
              await props.getLeadById(props.email?.data?.user_uuid);

              sessionStorage.setItem( "lead", JSON.stringify(props.email?.data?.user_uuid));
              setOpenSubscriptionModal(true);

              if(props?.ResRegister?.data?.hear_about_us)
              {
                setHowDoYouhearAboutUs(props?.ResRegister?.data?.hear_about_us?.[0]);
              }
            } else if (props.email?.data?.type === "commercial") {        
              const quote_uuid = props.email?.data?.commercial_quote_uuid;
              
              await props.getQuoteById(quote_uuid);
              
              setOpenSubscriptionModal(true);
              sessionStorage.setItem("quote", JSON.stringify(quote_uuid));

              await props.getCommercialProposal(quote_uuid);
              setQuoteUUId(quote_uuid);
            }
          }

          if (props.email?.data?.type === "new") {
            sessionStorage.setItem("is_new", JSON.stringify("true"));
            sessionStorage.setItem("email", JSON.stringify(email));
          } else {
            sessionStorage.setItem("is_new", JSON.stringify("false"));
          }
        }
      }
    })();
  }, [props.email]);

  async function verifyEmail() {
    if (email === "" || !REGULAR_EXPRESSION_EMAIL.test(email)) {
      let temp_errors = errors;
      let email_error = email === "" ? "Enter Email address" : "Invalid Email Address";
      Object.assign(temp_errors, { email: email_error });

      setErrors(temp_errors);
      setValidEmail(false);
    } else {
      setErrors({});
      setValidEmail(true);
      await props.verifyEmail(email);
    }
  }

  async function onContinue() {
    setLoader(true);
    setContinueFlag(true);
    setIsProcessing(true);

    if ( validEmail && !props.emailInUse &&
      howDoYouhearAboutUs !== "" && selectedServiceType !== "")
    {
      let params;
      const area = JSON.parse(sessionStorage.getItem("area"));
      const scorpion_id = localStorage.getItem("scorpion_id");
      const channel = JSON.parse(localStorage.getItem("scorpion_channel"));
      const lead_uuid = JSON.parse(sessionStorage.getItem("lead"));

      if (selectedServiceType === "commercial")
      {
        if (channel) {
          params = {
            outreach: "website",
            email_address: email,
            zip_code: area.zipcode,
            field_office_uuid: area.uuid,
            channel_attribution_id: channel,
            hear_about_us: [howDoYouhearAboutUs],
          };
        } else {
          params = {
            outreach: "website",
            email_address: email,
            zip_code: area.zipcode,
            field_office_uuid: area.uuid,
            hear_about_us: [howDoYouhearAboutUs],
          };
        }

        if(scorpion_id && scorpion_id != "")
        {
          Object.assign(params, {scorpion_id});
        }

        if(!isProcessing)
        {
          await props.addCommercialQuote(params);
        }
      } else if (selectedServiceType === "residential") {
        if (channel) {
          params = {
            zip_code: area.zipcode,
            emailaddress_set: [
              {
                email: email,
                primary: true,
              },
            ],
            lead_stage: "new",
            outreach: "website",
            hear_about_us: [howDoYouhearAboutUs],
            email: email,
            role: ["lead"],
            field_office_uuid: area.uuid,
            channel_attribution_id: channel,
          };
        } else {
          params = {
            zip_code: area.zipcode,
            emailaddress_set: [
              {
                email: email,
                primary: true,
              },
            ],
            lead_stage: "new",
            outreach: "website",
            hear_about_us: [howDoYouhearAboutUs],
            email: email,
            role: ["lead"],
            field_office_uuid: area.uuid,
          };
        }

        if(scorpion_id && scorpion_id != "")
        {
          Object.assign(params, {scorpion_id});
        }

        if (!isExistingCustomer || !props?.CustomerStep?.data?.lead_residential) {
          await props.createLead(params);
        }
        else {
          params.is_crm = false;
          await props.updateLead(lead_uuid, params);
        }
      }
    } else {
      let temp_errors = {};
      
      if ( email === "" || !validEmail || props.emailInUse || (errors  && errors["email"]))
      {
        let email_error_message = "";
        if((errors  && errors["email"])){
          email_error_message = errors["email"];
        }else  if( email === "" || !validEmail ){
          email_error_message =  "Enter Email address";
        }
        
        Object.assign(temp_errors, { email: email_error_message });
      }

      if (howDoYouhearAboutUs === "") {
        Object.assign(temp_errors, {
          hear_about_us: "Please select an option",
        });
      }

      if (selectedServiceType === "") {
        Object.assign(temp_errors, {
          service_type: "Please select the service type that you require",
        });
      }

      setErrors(temp_errors);
    }
  }

  return (
    <Layout>
      <div className="page_inner_content">
        <div className="zip_code_wrapper">
          <div className="container">
            <div className="row">
              <div className="col-md-5">
                <div className="center_card">
                  <div className="zip_card_box ">
                    <h1>Hooray!</h1>

                    <p className="sub_title">
                      We&apos;re in your area! Customize your quote for a
                      cleaner, greener yard now!
                    </p>
                    <div className="single_control">
                      <label>
                        Email <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="text"
                        name="email"
                        value={email}
                        className="form--control"
                        placeholder="email@example.com"
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                        onBlur={verifyEmail}
                        required
                      />
                      {errors["email"] ? (
                        <label className="new_err_msg">
                          <i className="las la-info-circle" />
                          {errors["email"]}
                        </label>
                      ) : (
                        ""
                      )}
                    </div>
                    <div
                      className="multi_control"
                      style={{
                        display: "flex",
                        flexFlow: "column",
                        marginTop: "10px",
                      }}
                    >
                      <label>
                        How did you hear about us?
                        <span style={{ color: "red" }}>*</span>
                      </label>
                      <Select
                        defaultValue=""
                        id="how_do_you_hear"
                        name="how_do_you_hear"
                        className="form-control hear_about"
                        value={howDoYouhearAboutUs}
                        onChange={(value) => {
                          setHowDoYouhearAboutUs(value);
                          
                        }}
                      >
                        {howDoYouhearAboutUs === "" ? (
                          <Option value="">Select an option</Option>
                        ) : null}
                        {options?.map((item) => (
                          <Option id={item.id} value={item.value} key={item.id}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                      {errors["hear_about_us"] ? (
                        <label className="new_err_msg">
                          <i className="las la-info-circle" />
                          {errors["hear_about_us"]}
                        </label>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="service_type_wrapper">
                      <div
                        className={`service_box col opbox ${
                          selectedServiceType === "residential"
                            ? "selected"
                            : ""
                        }`}
                        onClick={() => setSelectedServiceType("residential")}
                      >
                        <span className="title">Residential</span>
                        <div className="img_div">
                          <img
                            src={require("../../Assets/images/home.svg")}
                            alt=""
                          />
                        </div>
                        <label className="desc">
                          I need you to clean up after my dog in my own yard.
                        </label>
                      </div>
                      <div
                        className={`service_box col opbox ${
                          selectedServiceType === "commercial" ? "selected" : ""
                        }`}
                        onClick={() => {
                          setSelectedServiceType("commercial");
                        }}
                      >
                        <span className="title">Community</span>
                        <div className="img_div">
                          <img
                            src={require("../../Assets/images/homes.svg")}
                            alt=""
                          />
                        </div>
                        <label className="desc">
                          We need help managing pet waste in our community.
                        </label>
                      </div>
                    </div>
                    {errors["service_type"] ? (
                      <label className="new_err_msg">
                        <i className="las la-info-circle" />
                        {errors["service_type"]}
                      </label>
                    ) : (
                      ""
                    )}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <label
                        className="back_arrow cursor_pointer"
                        onClick={() => {
                          window.history.back();
                        }}
                      >
                        <i className="las la-arrow-left"></i>
                        Back
                      </label>
                      <label
                        className="next_arrow cursor_pointer"
                        onClick={onContinue}
                      >
                        Continue
                        <i
                          className="las la-arrow-right"
                          style={{ marginLeft: "10px", marginRight: "0px" }}
                        ></i>
                      </label>
                    </div>

                    <div style={{marginTop: "25px"}}>
                      <span style={{fontSize: "12px", color: "grey"}}>
                        By clicking continue above, you consent to receive marketing emails from us.
                      </span>                               
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        className="new_card_pupup"
        visible={openModal}
        onCancel={() => setOpenModal(false)}
        footer={[
          <Button
            key="cancel"
            className="btn btn--secondary"
            onClick={() => setOpenModal(false)}
          >
            Close
          </Button>,
        ]}
      >
        {staffModal ? <div> <h4> <span dangerouslySetInnerHTML={{__html: staffModalData}}></span> </h4></div> :
        <div>
          <h2>This Email is already registered.</h2>
          <br/>
          <p>
            Click here to{" "}
            <a
              onClick={(e) => {
                // e.preventDefault();
                getHistoricalData(true);
              }}
              href={`${origin}/login`}
              target="_blank"
            >
              login
            </a>
          </p>
          <a
            href={`${origin}/login`}
            target="_blank"
          >
            Reset Password
          </a>
          <br/>
          <p>
            <label>
              Questions?{" "}
              <a
                href="https://www.doodycalls.com/contact-us/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Contact Us
              </a>
            </label>
            <label>&nbsp;at&nbsp;</label>
            <a
              href="/#"
              onClick={(e) => {
                e.preventDefault();
              }}
            >
              <i className="las la-phone"></i>
              1-(888) 659-6558 
            </a>
            <label>&nbsp;for further assistance</label>
          </p>
        </div>}
      </Modal>
      <Modal
        className="new_card_pupup"
        visible={openSubscriptionModal}
        onCancel={() => setOpenSubscriptionModal(false)}
        footer={[
          <Button
            key="cancel"
            className="btn btn--secondary"
            onClick={() => {
              setOpenSubscriptionModal(false)
            }}
          >
            Ok
          </Button>,
        ]}
      >
        <div>
          <h2>This Email is already registered. Any new selection will overwrite your previous enquiry</h2>
          <br/>
          <p>
            <label>
              Questions?{" "}
              <a
                href="https://www.doodycalls.com/contact-us/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Contact Us
              </a>
            </label>
            <label>&nbsp;at&nbsp;</label>
            <a
              href="/#"
              onClick={(e) => {
                e.preventDefault();
              }}
            >
              <i className="las la-phone"></i>
              1-(888) 659-6558 
            </a>
            <label>&nbsp;for further assistance</label>
          </p>
        </div>
      </Modal>

      {loader && (
        <div className="loader_wrapper">
          <div className="loader07"></div>
        </div>
      )}
    </Layout>
  );
}

export default ServiceType;
